// Brand + content data for ROYALE Thai Therapeutic Massage

export const BRAND = {
  name: "ROYALE",
  subtitle: "Thai Therapeutic Massage",
  tagline: "Care for your Body · Skin & Soul",
  location: "Barcelona",
  phoneDisplay: "+34 653 021 796",
  phoneRaw: "34653021796",
  email: "Royalegspot@gmail.com",
  facebook: "Royale Therapeutic Massage",
  facebookUrl: "https://www.facebook.com/",
  address: "Calle Constitució 24, Sants-Montjuïc, Barcelona",
  mapQuery: "Calle Constitucio 24, Sants-Montjuic, Barcelona",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/me6y7tsp_1_20260706_182331_0000.png",
};

export const whatsappLink = (message) =>
  `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(
    message || "Hola Royale, me gustaría reservar una sesión de masaje."
  )}`;

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "pricing", label: "Prices" },
  { id: "about", label: "About" },
  { id: "gallery", label: "Gallery" },
  { id: "testimonials", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const SERVICES = [
  {
    name: "Traditional Thai Massage",
    price: "€70",
    desc: "Ancient assisted stretching and rhythmic pressure along the body's energy lines to release deep tension.",
    img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/6wbjhc1a_46266f084ce482841f17fc40de080084.jpg",
  },
  {
    name: "Aromatherapy Massage",
    price: "€68",
    desc: "Warm essential oils and flowing strokes that calm the nervous system and restore balance.",
    img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/94hld57n_25fcd0f1f682b5ae41eafcc0d1397b5c.jpg",
  },
  {
    name: "Candle Ritual Massage",
    price: "€70",
    desc: "Nourishing warm massage candle melted into a silky balm for an indulgent, deeply hydrating ritual.",
    img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/mf25ho6m_7c3bf9795e6d50dfebf21a81e1a7e6ac.jpg",
  },
  {
    name: "Thai Herbal Heat · Pindas",
    price: "€75",
    desc: "Steamed herbal compresses pressed into tired muscles, blending heat and Thai botanicals.",
    img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/4xvsgnhq_d8fa6a1ec6ef0caf94a301deaa5aaa56.jpg",
  },
  {
    name: "Mother-to-be Massage",
    price: "€68",
    desc: "Gentle, supportive care designed to soothe and comfort during pregnancy · Futuro Mamá.",
    img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/czuyy2vx_d23c911968a63985c31c5b1951754924.jpg",
  },
  {
    name: "Royale Facial",
    price: "€38 / €60",
    desc: "A radiant facial treatment tailored to your skin, leaving it refreshed, glowing and renewed.",
    img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/g5s7ujz5_7b261e545282c832243d6caf9b21c822.jpg",
  },
];

export const PRICE_GROUPS = [
  {
    title: "Massage Therapies",
    items: [
      { name: "Aromatherapy Massage", price: "€68" },
      { name: "Mother-to-be Massage · Futuro Mamá", price: "€68" },
      { name: "Candle Ritual", price: "€70" },
      { name: "Traditional Thai Massage", price: "€70" },
      { name: "Thai Herbal Heat · Pindas", price: "€75" },
    ],
  },
  {
    title: "Spa Packages",
    items: [
      { name: "Massage + Facial", price: "€105 / €125" },
      { name: "Massage + Localizar", price: "€105" },
    ],
  },
  {
    title: "Localizados",
    items: [
      { name: "Royale Facial · 30m / 60m", price: "€38 / €60" },
      { name: "Royale Head · Asian Head · 30m", price: "€38" },
      { name: "Royale Back · Oriental · 30m", price: "€38" },
      { name: "Royale Legs / Foot · Reflexology · 30m", price: "€38" },
    ],
  },
];

export const GALLERY = [
  { img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/yzsetum8_Messenger_creation_95AE4D2A-A569-4CC3-A81E-5A7EFB84CE0F.webp", alt: "Royale treatment room", span: "tall" },
  { img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/6wbjhc1a_46266f084ce482841f17fc40de080084.jpg", alt: "Traditional Thai massage", span: "wide" },
  { img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/mf25ho6m_7c3bf9795e6d50dfebf21a81e1a7e6ac.jpg", alt: "Candle ritual massage", span: "" },
  { img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/czuyy2vx_d23c911968a63985c31c5b1951754924.jpg", alt: "Mother-to-be massage", span: "" },
  { img: "https://customer-assets.emergentagent.com/job_zen-massage-retreat/artifacts/4xvsgnhq_d8fa6a1ec6ef0caf94a301deaa5aaa56.jpg", alt: "Thai herbal heat compress", span: "wide" },
  { img: "https://images.unsplash.com/photo-1763182198113-a9a8d0fe3144?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", alt: "Lotus on serene water", span: "tall" },
];

export const TESTIMONIALS = [
  {
    quote:
      "The most relaxing hour I've spent in Barcelona. The Thai massage left me feeling completely renewed — I've already booked my next session.",
    name: "Marta L.",
    detail: "Traditional Thai Massage",
  },
  {
    quote:
      "Regina has magic hands. The candle ritual was pure indulgence and my skin has never felt so soft. A true hidden gem in Sants-Montjuïc.",
    name: "Sophie R.",
    detail: "Candle Ritual Massage",
  },
  {
    quote:
      "As a mother-to-be I was nervous, but the care and gentleness were incredible. I felt safe, pampered and deeply relaxed throughout.",
    name: "Núria B.",
    detail: "Mother-to-be Massage",
  },
];
